/* istanbul ignore file -- @preserve */
/**
 * envがlocal, dev, testの場合true
 */
export const isDevEnv = (): boolean => {
  return ['local', 'dev', 'test'].includes(process.env.ENV);
};
